// A little variety on the returning-sender greeting so the entry page
// doesn't say the exact same line every single visit. Picks randomly from
// a mix of generic and time-of-day-aware phrasings each time it's called.
export function getGreeting(name: string): string {
  const hour = new Date().getHours();
  const timeOfDay = hour < 5 ? "Still up" : hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";

  const options = [
    `Welcome back, ${name}!`,
    `Hey, ${name}!`,
    `${timeOfDay}, ${name}!`,
    `Hi ${name}!`,
    `Good to see you, ${name}!`,
  ];

  return options[Math.floor(Math.random() * options.length)] ?? options[0]!;
}
